import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'filterBy'
})
export class FilterByPipe implements PipeTransform {
    transform(items: Array<any>, atribute: string, id: number): Array<any> {
        if (id > 0) {
            return items.filter(item => item[atribute] === id);
        } else {
            return items;
        }
    }
}
